import { PageHelper } from '@/pages/helper.ts';
import { trlMessage } from '@/services/i18n';
import {
  CALENDARS_ROUTE_NAME,
  EMAILS_ROUTE_NAME,
  MAGIC_BUTTON_ROUTE_NAME,
  ORGANIZATIONS_ROUTE_NAME,
  PERSONAL_ROUTE_NAME,
  SOCIAL_ROUTE_NAME
} from './constants';

const routes = [
  {
    name: PERSONAL_ROUTE_NAME,
    path: '/',
    component: () => PageHelper.lazyLoadView(import('../pages/personal')),
    meta: {
      text: trlMessage('settings.tab.my_profile'),
      tab: PERSONAL_ROUTE_NAME
    }
  },
  {
    name: ORGANIZATIONS_ROUTE_NAME,
    path: '/orgs',
    component: () => PageHelper.lazyLoadView(import('../pages/organizations')),
    meta: {
      text: trlMessage('settings.tab.organizations'),
      tab: ORGANIZATIONS_ROUTE_NAME
    }
  },
  {
    name: SOCIAL_ROUTE_NAME,
    path: '/social',
    component: () => PageHelper.lazyLoadView(import('../pages/social')),
    meta: {
      text: trlMessage('settings.tab.jobsites'),
      tab: SOCIAL_ROUTE_NAME
    }
  },
  {
    name: CALENDARS_ROUTE_NAME,
    path: '/calendars',
    component: () => PageHelper.lazyLoadView(import('../pages/calendar')),
    meta: {
      text: trlMessage('settings.tab.calendars'),
      tab: CALENDARS_ROUTE_NAME
    }
  },
  {
    name: EMAILS_ROUTE_NAME,
    path: '/emails',
    component: () => PageHelper.lazyLoadView(import('../pages/email')),
    meta: {
      text: trlMessage('settings.tab.emails'),
      tab: EMAILS_ROUTE_NAME
    }
  },
  {
    name: MAGIC_BUTTON_ROUTE_NAME,
    path: '/magic',
    component: () => PageHelper.lazyLoadView(import('../pages/magic-button')),
    meta: {
      text: trlMessage('settings.tab.magic-button'),
      tab: MAGIC_BUTTON_ROUTE_NAME
    }
  }
];

export default routes;
